<div class="sidebar">
    <!-- LOGO -->
    <div class="logo">
        <img src="assets/optima_logo.png" style= "width:200px; height:auto">
    </div>
    <!-- USER -->
    <div class="user" style="background-color: #EFEEE7;">
        <img src="assets/icone_varie/avatar_segnaposto_primary.svg" *ngIf="userInfo?.user_id == currentUser?.user_id">
        <img src="assets/icone_varie/avatar_segnaposto_red.svg" *ngIf="userInfo?.user_id != currentUser?.user_id">
        <div>
            <span style="cursor: pointer;" title="Profilo" [routerLink]="['./profile']">{{userInfo?.denominazione}}</span>
        <!--<div ngbDropdown class="d-inline-block">
                <button class="btn btn-primary" id="dropdownBasic1" ngbDropdownToggle>
                    <img [src]="'assets/icone_varie/' + (translate.getDefaultLang() == 'it' ? 'ita' : 'eng') + '.svg'" style="margin-right: 5px;">
                    {{translate.getDefaultLang() == 'it' ? "ITA" : "ENG"}}
                    <img [src]="'assets/icone_varie/arrow_down.svg'" style="width: 10px;">
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button style="color: var(--fontColor);" *ngIf="translate.getDefaultLang() != 'it'" ngbDropdownItem (click)="changeLanguage('it')"><img src="assets/icone_varie/ita.svg" style="margin-right: 10px;">ITA</button>
                    <button style="color: var(--fontColor);" *ngIf="translate.getDefaultLang() != 'en'" ngbDropdownItem (click)="changeLanguage('en')"><img src="assets/icone_varie/eng.svg" style="margin-right: 10px;">ENG</button>
                </div>
            </div>-->
            <span style="cursor: pointer;" (click)="optima()">Torna a OptimaSmart</span>
            <span style="cursor: pointer;" (click)="logout()">Logout</span>
        </div>
    </div>
    <!-- ITEM -->
    <div class="items" *ngIf="!invoiceMode" style="background-color: #EFEEE7;">
        <div *ngFor="let conf of _userConfigSidebar" class="item" [ngClass]="{'active': router.url.includes('main/' + conf.url)}" [routerLink]="conf.url" (click)='resetSessionUser(conf.url)'>
           <!-- <img [src]="'assets/icone_menu/' + (router.url.includes('main/' + conf.url) ? conf.icon_active : conf.icon)">-->
           <i class="{{router.url.includes('main/' + conf.url) ? conf.icon_active : conf.icon}}"></i>
            <span class="roboMenu">{{conf.label | translate}}</span>
        </div>
    </div>
    <div class="items" *ngIf="invoiceMode">
        <div class="item goBack" [routerLink]="['/main/invoices']">
            <i class="bi bi-caret-left-fill"></i>
           
            <span class="roboMenu">{{ 'general.back' | translate}}</span>
        </div>
    </div>
    <app-barra-riepilogo></app-barra-riepilogo>
    <div class="footer" style="background-color: #EFEEE7;">
        <span  (click)="openChangeLog()" placement="top" [ngbTooltip]="tooltipVersion" >AR4M S.r.l.&nbsp;&nbsp;
            <i class="bi bi-info-circle"></i>
            <!--<img [src]="'assets/icone_varie/changelog.svg'" style="width: 1rem; margin-left: 1rem; cursor: pointer;" (click)="openChangeLog()" placement="top" [ngbTooltip]="tooltipVersion">-->
        </span>
    </div>
</div>
